import { ApiError } from '../api/client.js';

/**
 * Last-resort user-facing message for an error. Each page's prettyError()
 * should still handle its business-specific codes (e.g. slug_taken), but
 * fall through to here for everything else — that way 500s with a stable
 * error_id always tell users what to quote in a support request, and we
 * never accidentally show 'internal_error' as a raw label.
 */
export function formatUnexpectedError(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.status >= 500) {
      const id = err.errorId;
      return id
        ? `Something went wrong on our end (reference ${id}). If it keeps happening, email support@adhoc.space and include that code.`
        : 'Something went wrong on our end. Try again in a moment.';
    }
    if (err.status === 429) {
      return 'Too many attempts. Try again in a minute.';
    }
    const code = err.code;
    if (code) return code.replace(/_/g, ' ');
    return 'Request failed.';
  }
  return 'Something went wrong.';
}
